import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import invariant from "tiny-invariant"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function ensure<T>(condition: T, message?: string): NonNullable<T> {
  invariant(condition, message)

  return condition
}
